var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animated-number',{attrs:{"value":_vm.value,"duration":1000,"formatValue":_vm.trim,"delay":100,"easing":"easeInOutQuint"}})}
var staticRenderFns = []

export { render, staticRenderFns }